var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-guide-selection-stats"},[(_vm.isHarness)?[_c('HarnessSelectionStats',{attrs:{"selection-stats":_vm.stats,"is-mobile":_vm.isMobile}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }